import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/wecom',
  component: Layout,
  name: 'Wecom',
  meta: {
    title: '企业微信',
    icon: 'i-ri:wechat-line',
    auth: 'wecom',
  },
  children: [
    {
      path: 'workbench-config',
      name: 'WecomWorkbenchConfig',
      component: () => import('@/views/wecom/workbench-config/index.vue'),
      meta: {
        title: '工作台配置',
        icon: 'i-ep:data-analysis',
        auth: 'wecom:workbench_config',
      },
    },
    {
      path: 'external-group-chat',
      name: 'WecomExternalGroupChat',
      component: () => import('@/views/wecom/external-group-chat/index.vue'),
      meta: {
        title: '客户群',
        icon: 'i-ant-design:team-outlined',
        auth: 'wecom:external_group_chat',
      },
    },
  ],
}

export default routes
